/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ChatAgent.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateCustomerRequest,
  GetApiWorkspacesWorkspaceIdCustomersParams,
  UpdateCustomerRequest
} from '.././model';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getApiWorkspacesWorkspaceIdCustomers = (
    workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdCustomersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/customers`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdCustomersQueryKey = (workspaceId?: string,
    params?: GetApiWorkspacesWorkspaceIdCustomersParams,) => {
    return [
    `/api/workspaces/${workspaceId}/customers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError = unknown>(workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdCustomersQueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>> = ({ signal }) => getApiWorkspacesWorkspaceIdCustomers(workspaceId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>>
export type GetApiWorkspacesWorkspaceIdCustomersQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdCustomers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetApiWorkspacesWorkspaceIdCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdCustomers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError = unknown>(
 workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdCustomers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError = unknown>(
 workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdCustomers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError = unknown>(
 workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdCustomersQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiWorkspacesWorkspaceIdCustomers = (
    workspaceId: string,
    createCustomerRequest: CreateCustomerRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomerRequest, signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdCustomersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdCustomers>>, TError,{workspaceId: string;data: CreateCustomerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdCustomers>>, TError,{workspaceId: string;data: CreateCustomerRequest}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdCustomers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdCustomers>>, {workspaceId: string;data: CreateCustomerRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  postApiWorkspacesWorkspaceIdCustomers(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdCustomersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdCustomers>>>
    export type PostApiWorkspacesWorkspaceIdCustomersMutationBody = CreateCustomerRequest
    export type PostApiWorkspacesWorkspaceIdCustomersMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdCustomers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdCustomers>>, TError,{workspaceId: string;data: CreateCustomerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdCustomers>>,
        TError,
        {workspaceId: string;data: CreateCustomerRequest},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdCustomersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiWorkspacesWorkspaceIdCustomersCustomerId = (
    workspaceId: string,
    customerId: string,
    updateCustomerRequest: UpdateCustomerRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/customers/${customerId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomerRequest
    },
      options);
    }
  


export const getPutApiWorkspacesWorkspaceIdCustomersCustomerIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdCustomersCustomerId>>, TError,{workspaceId: string;customerId: string;data: UpdateCustomerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdCustomersCustomerId>>, TError,{workspaceId: string;customerId: string;data: UpdateCustomerRequest}, TContext> => {

const mutationKey = ['putApiWorkspacesWorkspaceIdCustomersCustomerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdCustomersCustomerId>>, {workspaceId: string;customerId: string;data: UpdateCustomerRequest}> = (props) => {
          const {workspaceId,customerId,data} = props ?? {};

          return  putApiWorkspacesWorkspaceIdCustomersCustomerId(workspaceId,customerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspacesWorkspaceIdCustomersCustomerIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdCustomersCustomerId>>>
    export type PutApiWorkspacesWorkspaceIdCustomersCustomerIdMutationBody = UpdateCustomerRequest
    export type PutApiWorkspacesWorkspaceIdCustomersCustomerIdMutationError = unknown

    export const usePutApiWorkspacesWorkspaceIdCustomersCustomerId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdCustomersCustomerId>>, TError,{workspaceId: string;customerId: string;data: UpdateCustomerRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdCustomersCustomerId>>,
        TError,
        {workspaceId: string;customerId: string;data: UpdateCustomerRequest},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspacesWorkspaceIdCustomersCustomerIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    